module.exports = __webpack_public_path__ + "static/media/pc3.1dcdb7d2.jpg";